/*
  Collection sort / filter drawer and grid switcher.
  Markup: snippets/collection-toolbar.liquid. Styles: custom.css (.ndg-toolbar, .ndg-filter).
  Filtering re-renders the main-collection section via the Section Rendering
  API and swaps in the product grid and the drawer contents.

  Color is the exception: Search & Discovery can't filter on custom.color, so
  the Color group is built here from the cards' own colours (data-ndg-colors:
  each product's custom.color, set in snippets/product-grid-item.liquid). So
  the list holds only the colours the products in the current results (the
  other filters applied) actually are, and a card matches only when it is in
  the picked colour; the other colours its style comes in do not count. The
  choice lives in the URL as ndg_color. With a colour picked, the other
  filters' values that no product in that colour has are disabled too
  (data-ndg-facets on the cards, see snippets/card-filter-facets.liquid).
*/
(function () {
  var GRID_KEY = 'ndg-collection-grid';
  var drawer = document.getElementById('NdgFilterDrawer');
  var section = document.getElementById('main-collection-product-grid');
  if (!drawer || !section) return;

  // The drawer is rendered inside the section; move it to <body> so that
  // position: fixed covers the header regardless of parent stacking contexts.
  document.body.appendChild(drawer);

  var sectionId = drawer.getAttribute('data-section-id');
  var lastTrigger = null;
  var priceTimer = null;
  var requestId = 0;

  /* ---------- Drawer open / close ---------- */

  function openDrawer(trigger) {
    lastTrigger = trigger || null;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ndg-filter-lock');
    setExpanded(true);
    var close = drawer.querySelector('.ndg-filter__close');
    if (close) close.focus();
    colorFilter.updateList(); // retries if the list failed to load earlier
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ndg-filter-lock');
    setExpanded(false);
    if (lastTrigger) lastTrigger.focus();
  }

  function setExpanded(open) {
    var btn = document.querySelector('[data-ndg-filter-open]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-ndg-filter-open]');
    if (openBtn) {
      openDrawer(openBtn);
      return;
    }
    // e.target === drawer: a click on the backdrop beside the 350px panel (768px+)
    if (e.target === drawer || e.target.closest('[data-ndg-filter-close]')) {
      closeDrawer();
      return;
    }
    var clear = e.target.closest('[data-ndg-filter-clear]');
    if (clear) {
      e.preventDefault();
      colorFilter.clear();
      render(new URL(clear.href, window.location.origin).searchParams.toString());
      return;
    }
    var gridBtn = e.target.closest('[data-ndg-grid]');
    if (gridBtn) setGrid(gridBtn.getAttribute('data-ndg-grid'), true);
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* ---------- Filtering ---------- */

  function formParams() {
    var params = new URLSearchParams();
    new FormData(drawer.querySelector('form')).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    return params.toString();
  }

  drawer.addEventListener('change', function (e) {
    if (e.target.matches('[data-ndg-price]')) return;
    if (e.target.name === 'ndg_color') {
      colorFilter.onChange(e.target);
      return;
    }
    render(formParams());
  });

  drawer.addEventListener('input', function (e) {
    if (!e.target.matches('[data-ndg-price]')) return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(function () {
      render(formParams());
    }, 800);
  });

  drawer.addEventListener('submit', function (e) {
    e.preventDefault();
    render(formParams());
  });

  function render(params, pushState) {
    var id = ++requestId;
    var grid = document.getElementById('CollectionProductGrid');
    if (grid) grid.classList.add('ndg-is-loading');
    drawer.classList.add('is-loading');

    var url = window.location.pathname + '?section_id=' + sectionId + (params ? '&' + params : '');
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        if (id !== requestId) return; // a newer request has started
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swap(doc, '#CollectionProductGrid', document.getElementById('CollectionProductGrid'));
        swap(doc, '[data-ndg-active-count]', document.querySelector('[data-ndg-active-count]'));
        swap(doc, '[data-ndg-filter-footer]', drawer.querySelector('[data-ndg-filter-footer]'));
        // The server sends the Color group empty; keep the current one, which
        // the script then updates for the new results.
        var colorGroup = drawer.querySelector('[data-ndg-color-filter]');
        swapKeepingFocus(doc);
        var freshGroup = drawer.querySelector('[data-ndg-color-filter]');
        if (colorGroup && freshGroup) freshGroup.replaceWith(colorGroup);
        colorFilter.afterRender(params);
        if (pushState !== false) {
          history.pushState({ ndgParams: params }, '', window.location.pathname + (params ? '?' + params : ''));
        }
      })
      .catch(function () {
        window.location.search = params;
      })
      .finally(function () {
        if (id !== requestId) return;
        var g = document.getElementById('CollectionProductGrid');
        if (g) g.classList.remove('ndg-is-loading');
        drawer.classList.remove('is-loading');
      });
  }

  function swap(doc, selector, target) {
    var source = doc.querySelector(selector);
    if (source && target) target.innerHTML = source.innerHTML;
  }

  // Re-render the drawer body (counts, disabled values) without losing the
  // scroll position or the caret of a price field being typed in.
  function swapKeepingFocus(doc) {
    var body = drawer.querySelector('[data-ndg-filter-body]');
    var active = document.activeElement;
    var focusId = active && body.contains(active) ? active.id : null;
    var caret = null;
    if (focusId && active.type === 'number') caret = active.value;
    var scroll = body.scrollTop;

    swap(doc, '[data-ndg-filter-body]', body);
    body.scrollTop = scroll;

    if (focusId) {
      var el = document.getElementById(focusId);
      if (el) {
        if (caret !== null) el.value = caret;
        el.focus();
      }
    }
  }

  window.addEventListener('popstate', function (e) {
    if (!e.state || e.state.ndgParams === undefined) {
      render(window.location.search.slice(1), false);
      return;
    }
    render(e.state.ndgParams, false);
  });

  /* ---------- Color (client side) ---------- */

  var colorFilter = (function () {
    var selected = [];

    function grid() {
      return document.getElementById('CollectionProductGrid');
    }

    function cards() {
      var g = grid();
      return g ? Array.prototype.slice.call(g.querySelectorAll('.collection-list > li')) : [];
    }

    // Product cards only: skip the filler cells and full-width rows.
    function productCards() {
      return cards().filter(function (li) {
        return li.getAttribute('role') !== 'presentation' && !li.classList.contains('col-span-full');
      });
    }

    // The card's own colour as a one-item list: [{ k: key, l: label, s: CSS background }].
    function colorsOf(el) {
      var wrapper = el.matches('[data-ndg-colors]') ? el : el.querySelector('[data-ndg-colors]');
      if (!wrapper) return [];
      try { return JSON.parse(wrapper.getAttribute('data-ndg-colors')) || []; } catch (err) { return []; }
    }

    function readUrl() {
      selected = new URLSearchParams(window.location.search).getAll('ndg_color').slice(0, 1);
    }

    function writeUrl() {
      var params = new URLSearchParams(window.location.search);
      params.delete('ndg_color');
      selected.forEach(function (c) { params.append('ndg_color', c); });
      var query = params.toString();
      history.replaceState(history.state, '', window.location.pathname + (query ? '?' + query : ''));
    }

    // "Show more" (custom.js) loads one page per click; click it until every
    // page is in, so the colour list and the filtering cover the whole
    // collection, not just the first page.
    function loadAll() {
      return new Promise(function (resolve) {
        var tries = 0;
        (function step() {
          var button = document.querySelector('[data-collection-show-more-button]');
          if (!button || tries > 60) return resolve();
          if (button.getAttribute('aria-busy') !== 'true') {
            tries++;
            button.click();
          }
          setTimeout(step, 150);
        })();
      });
    }

    // The Search & Discovery filters of a query string: no colour, page or
    // sort, so one colour list serves every page and sort order.
    function filterQuery(search) {
      var params = new URLSearchParams(search);
      ['ndg_color', 'page', 'sort_by', 'section_id'].forEach(function (key) { params.delete(key); });
      return params.toString();
    }

    function fetchPage(q, page) {
      return fetch(window.location.pathname + '?section_id=' + sectionId + (q ? '&' + q : '') + '&page=' + page)
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }

    // A filter value as the cards list it in data-ndg-facets.
    function facetKey(name, value) {
      return (name + '=' + value).toLowerCase();
    }

    // The coloured cards of a result set (the collection with the given
    // Search & Discovery filters, all pages: page 1 says how many there are,
    // the rest come in parallel) as [{ colors: [{ k, l, s }], facets: { key:
    // true } }]. Cached per filter combination; null when a fetch failed (not
    // cached, so the next call retries).
    var query = filterQuery(window.location.search);
    var cardLists = {};
    function resultCards(q) {
      if (cardLists[q]) return cardLists[q];
      cardLists[q] = fetchPage(q, 1)
        .then(function (first) {
          var grid = first.querySelector('[data-ndg-pages]');
          var pages = Math.min(grid ? parseInt(grid.getAttribute('data-ndg-pages'), 10) || 1 : 1, 20);
          var rest = [];
          for (var page = 2; page <= pages; page++) rest.push(fetchPage(q, page));
          return Promise.all(rest).then(function (docs) { return [first].concat(docs); });
        })
        .then(function (docs) {
          var list = [];
          docs.forEach(function (doc) {
            doc.querySelectorAll('[data-ndg-colors]').forEach(function (el) {
              var facets = {};
              try {
                (JSON.parse(el.getAttribute('data-ndg-facets') || '[]') || []).forEach(function (f) {
                  facets[String(f).toLowerCase()] = true;
                });
              } catch (err) {}
              list.push({ colors: colorsOf(el), facets: facets });
            });
          });
          return list;
        })
        .catch(function () {
          delete cardLists[q];
          return null;
        });
      return cardLists[q];
    }

    // Every colour in a result set, in order of first appearance; null when
    // the fetch failed.
    function resultColors(q) {
      return resultCards(q).then(function (cardList) {
        if (!cardList) return null;
        var seen = {};
        var list = [];
        cardList.forEach(function (card) {
          card.colors.forEach(function (c) {
            if (!c.k || seen[c.k]) return;
            seen[c.k] = true;
            list.push({ key: c.k, label: c.l, swatch: c.s });
          });
        });
        return list;
      });
    }

    // With a colour picked, a Search & Discovery value (size, material, ...)
    // is disabled when no product in that colour has it: Search & Discovery
    // only disables what the other filters rule out, it doesn't know the
    // colour. Like its counts, a group with values ticked is judged on the
    // results without that group's own filter. Ticked values stay enabled.
    var facetId = 0;
    function updateFacets() {
      var id = ++facetId;
      var groups = {};
      drawer.querySelectorAll('input[data-ndg-facet]').forEach(function (input) {
        (groups[input.name] = groups[input.name] || []).push(input);
      });
      var color = selected[0];

      Object.keys(groups).forEach(function (name) {
        var inputs = groups[name];
        if (!color) {
          inputs.forEach(function (input) { setColorDisabled(input, false); });
          return;
        }
        var q = query;
        var ticked = inputs.some(function (input) { return input.checked; });
        if (ticked) {
          var params = new URLSearchParams(query);
          params.delete(name);
          q = params.toString();
        }
        resultCards(q).then(function (cardList) {
          if (id !== facetId || !cardList) return; // stale, or the fetch failed
          var has = {};
          cardList.forEach(function (card) {
            var inColor = card.colors.some(function (c) { return c.k === color; });
            if (inColor) Object.keys(card.facets).forEach(function (key) { has[key] = true; });
          });
          inputs.forEach(function (input) {
            setColorDisabled(input, !input.checked && !has[facetKey(input.name, input.value)]);
          });
        });
      });
    }

    // Disables / re-enables a value for the picked colour, leaving alone the
    // values Search & Discovery itself disabled.
    function setColorDisabled(input, off) {
      var byColor = input.hasAttribute('data-ndg-color-disabled');
      if (off === byColor) return;
      if (off && input.disabled) return; // already disabled by Search & Discovery
      input.disabled = off;
      input.toggleAttribute('data-ndg-color-disabled', off);
      var option = input.closest('.ndg-filter__option');
      if (option) option.classList.toggle('is-disabled', off);
    }

    function build(list) {
      var group = drawer.querySelector('[data-ndg-color-filter]');
      var options = drawer.querySelector('[data-ndg-color-options]');
      if (!group || !options) return;

      options.innerHTML = '';
      list.forEach(function (color, i) {
        var id = 'NdgColor-' + i;
        var option = document.createElement('div');
        option.className = 'ndg-filter__color';

        var input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'visually-hidden';
        input.name = 'ndg_color';
        input.value = color.key;
        input.id = id;
        input.checked = selected.indexOf(color.key) !== -1;

        // Dot only; the name is the tooltip and the screen reader text.
        var label = document.createElement('label');
        label.setAttribute('for', id);
        label.title = color.label;
        var dot = document.createElement('span');
        dot.className = 'ndg-filter__swatch';
        dot.setAttribute('aria-hidden', 'true');
        if (color.swatch) dot.style.background = color.swatch;
        var text = document.createElement('span');
        text.className = 'visually-hidden';
        text.textContent = color.label;

        label.appendChild(dot);
        label.appendChild(text);
        option.appendChild(input);
        option.appendChild(label);
        options.appendChild(option);
      });

      group.hidden = list.length === 0;
    }

    function apply() {
      var active = selected.length > 0;
      section.classList.toggle('ndg-color-filtering', active);

      var shown = 0;
      productCards().forEach(function (li) {
        var match = !active || colorsOf(li).some(function (c) { return selected.indexOf(c.k) !== -1; });
        li.classList.toggle('ndg-color-hidden', !match);
        if (match) shown++;
      });

      // No card left: show the 'no products match' message (template in
      // snippets/collection-toolbar.liquid) at the top of the grid.
      var g = grid();
      var message = g && g.querySelector('[data-ndg-color-empty]');
      if (active && shown === 0 && g && !message) {
        var template = document.getElementById('NdgNoResultsTemplate');
        if (template) {
          message = template.content.firstElementChild.cloneNode(true);
          message.setAttribute('data-ndg-color-empty', '');
          g.insertBefore(message, g.firstChild);
        }
      } else if (message && !(active && shown === 0)) {
        message.remove();
      }

      var count = drawer.querySelector('[data-ndg-color-count]');
      if (count) count.textContent = active ? '(' + selected.length + ')' : '';

      // "View N results": the visible cards while a colour is picked.
      var results = drawer.querySelector('[data-ndg-results]');
      if (results) {
        var total = active ? shown : parseInt(results.getAttribute('data-count'), 10) || 0;
        var pattern = results.getAttribute(total === 1 ? 'data-label-one' : 'data-label-other') || '';
        results.textContent = pattern.replace(/\d+/, total);
      }

      // Toolbar "(N)": Search & Discovery filters plus picked colours.
      var badge = document.querySelector('[data-ndg-active-count]');
      if (badge) {
        if (!badge.hasAttribute('data-base')) {
          badge.setAttribute('data-base', parseInt((badge.textContent.match(/\d+/) || ['0'])[0], 10));
        }
        var n = parseInt(badge.getAttribute('data-base'), 10) + selected.length;
        badge.textContent = n > 0 ? '(' + n + ')' : '';
      }
    }

    // Brings the swatches up to date with the current results. Meanwhile the
    // group keeps what it shows (the previous swatches, or the placeholder
    // dots on first load), dimmed, rather than disappearing.
    var listId = 0;
    var builtQuery = null;
    function updateList() {
      if (builtQuery === query) return Promise.resolve();
      var id = ++listId;
      var group = drawer.querySelector('[data-ndg-color-filter]');
      setUpdating(group, true);
      return resultColors(query).then(function (list) {
        if (id !== listId) return; // the filters changed meanwhile
        setUpdating(group, false);
        if (!list) {
          // Fetch failed: keep the swatches shown, but don't leave
          // placeholder dots up.
          if (group && group.querySelector('.ndg-filter__swatch-placeholder')) group.hidden = true;
          return;
        }
        builtQuery = query;
        // A picked colour none of the results come in is no longer listed,
        // so drop it rather than hide every card behind it.
        var keys = list.map(function (c) { return c.key; });
        var kept = selected.filter(function (k) { return keys.indexOf(k) !== -1; });
        build(list);
        if (kept.length !== selected.length) {
          selected = kept;
          writeUrl();
          apply();
          updateFacets();
        }
      });
    }

    function setUpdating(group, on) {
      if (!group) return;
      group.classList.toggle('is-updating', on);
      group.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    // Cards: with a colour picked, every page must be in the grid first so
    // that none of the matching products is missed.
    function filterCards() {
      if (selected.length) {
        loadAll().then(apply);
      } else {
        apply();
      }
    }

    return {
      updateList: updateList,
      init: function () {
        readUrl();
        updateList();
        filterCards();
        updateFacets();
      },
      // One colour at a time: picking a colour unticks the others; clicking
      // the picked one again clears it (checkboxes, not radios, for that).
      onChange: function (input) {
        if (input && input.checked) {
          drawer.querySelectorAll('input[name="ndg_color"]').forEach(function (other) {
            if (other !== input) other.checked = false;
          });
        }
        selected = Array.prototype.map.call(drawer.querySelectorAll('input[name="ndg_color"]:checked'), function (i) { return i.value; });
        writeUrl();
        filterCards();
        updateFacets();
      },
      // A Search & Discovery filter re-rendered the grid (first page only):
      // the colour list follows the new results.
      afterRender: function (params) {
        var badge = document.querySelector('[data-ndg-active-count]');
        if (badge) badge.removeAttribute('data-base');
        query = filterQuery(params || '');
        readUrl();
        updateList();
        filterCards();
        updateFacets(); // the drawer body is the server's again
      },
      clear: function () {
        selected = [];
        writeUrl();
      }
    };
  })();

  /* ---------- Grid switcher ---------- */

  function setGrid(mode, save) {
    section.setAttribute('data-ndg-grid-mode', mode === 'large' ? 'large' : 'default');

    document.querySelectorAll('[data-ndg-grid]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-ndg-grid') === mode ? 'true' : 'false');
    });

    if (save) {
      try { localStorage.setItem(GRID_KEY, mode); } catch (err) {}
    }
  }

  setGrid(section.getAttribute('data-ndg-grid-mode') === 'large' ? 'large' : 'default', false);
  colorFilter.init();
})();
